var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 47.5 47.5",
    viewBox: "0 0 47.5 47.5",
    id: "file",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#269",
    d: "M0 0a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4h-9c-3.562 0-3 5-8.437 5H4a4 4 0 0 1-4-4V0Z",
    transform: "translate(1 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55acee",
    d: "M0 0h-6.562C-12 0-11.945-5-15.508-5h-9c-2.209 0-4.181-1.791-4.406-4l-.492-3.874L-29.93-17l-.02.002c-.115-.606-.672-.999-1.3-.999-.643 0-1.106.507-1.074 1.143-.002-.049-.012-.096-.012-.146a3.989 3.989 0 0 1 3.4-3.939 2.82 2.82 0 0 1 .6-.061h26c2.209 0 4.182 1.791 4.406 4L3.594-4C3.818-1.791 2.209 0 0 0",
    transform: "translate(33.336 25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.b38907bac3dcf8ab1aa31e8c531379e2.svg";
export { ForwardRef as ReactComponent };